module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red@2x-bfc63ead7b62f50f1b75c3d76b3c063e.png";